var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconSvg',_vm._b({attrs:{"viewBox":"0 0 48 48"}},'IconSvg',_vm.$attrs,false),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24 21.8864L11.6136 9.5L9.5 11.6136L21.8864 24L9.5 36.3864L11.6136 38.5L24 26.1136L36.3864 38.5L38.5 36.3864L26.1136 24L38.5 11.6136L36.3864 9.5L24 21.8864Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }